import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { useSocket } from "../context/SocketProvider";
import { useAuth } from "../auth/AuthProvider";
import axios from "axios";

import * as GroupStyle from "../styles/GroupSettings.style";
import { MediaQuery } from 'react-responsive';
import { Drawer } from 'antd';



//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버


interface UserData {
    id:string;
    name: string;
    role: string;
    // 필요한 다른 속성들...
}

interface Props {
    isOpen: boolean;
    onClose: () => void;
    currentUser: UserData | null;  
}

const UserInfoDrawer: React.FC<Props> = ({
    isOpen,
    onClose,
    currentUser,
}) => {

    const socket = useSocket();
    const { logout } = useAuth();

    const navigate = useNavigate();

    const handleVisitorPage = () => {
        navigate('/visitor'); 
    };  

    const handleRegisterPage = () => {
        navigate('/register'); 
    };      

    const handleLogout = () => {
        logout();
        navigate("/login");
    };    

    // 인라인 스타일 정의
    const infoSectionStyle = {
        backgroundColor: '#FFFFFF', // 정보 영역 배경색 (흰색)
        padding: '20px',
        borderRadius: '8px', // 모서리 둥글게
        border: '1px solid #E0E0E0', // 연한 테두리
        marginBottom: '30px', // 아래쪽 여백
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)', // 연한 그림자
    };

    const buttonContainerStyle = {
        padding: '10px 0',
    };

    const buttonStyle = {
        width: '100%', // 버튼 너비 꽉 채우기
        padding: '12px 20px',
        fontSize: '16px',
        margin: '10px 0', // 버튼 상하 여백
    };

    return (
        <>
        {/* <MediaQuery maxWidth={767}></MediaQuery>
        <MediaQuery minWidth={768}></MediaQuery> */}
            <Drawer
                open={isOpen}
                onClose={onClose}
                placement="left"
                width={500}
                footer={null}

                title={
                    <center><h4>계정 정보</h4></center>                
                }

                styles={{
                    body: {
                        backgroundColor: '#F7F7F7', // 연한 분홍색 (Drawer 전체 배경색)
                        padding: '24px', // 전체 패딩
                    },
                }}                
            >

{/* ---------------------------------------------------- */}
      {/* 1. ✨ 정보 표기 영역 (Info Section) ✨ */}
      {/* ---------------------------------------------------- */}
      <div style={infoSectionStyle}>
        <h5 style={{ margin: '5px 0' }}>
          계정: {currentUser?.id}
        </h5>
        <hr></hr>
        <h5 style={{ margin: '5px 0' }}>
          이름: {currentUser?.name}
        </h5>
        <hr></hr>
        <h5 style={{ margin: '5px 0' }}>
          권한: {currentUser?.role}
        </h5>
      </div>

      {/* ---------------------------------------------------- */}
      {/* 2. ✨ 버튼 영역 (Button Section) ✨ */}
      {/* ---------------------------------------------------- */}
      {/* 방문자 등록 버튼 */}
      {/* <div style={buttonContainerStyle}>
        <button
          onClick={handleVisitorPage}
          className={`btn btn-lg btn-secondary`}
          style={{ ...buttonStyle, backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white' }} 
        >
          방문자 등록 페이지 이동 🚀
        </button>
      </div> */}

      {/* 등록 버튼 */}
      {currentUser?.role !== "user" && (
        <div style={buttonContainerStyle}>
            <button
            onClick={handleRegisterPage}
            className={`btn btn-lg btn-info`}
            style={{ ...buttonStyle, backgroundColor: '#9c51b9ff', borderColor: '#9c51b9ff', color: 'white' }} 
            >
            등록 페이지 이동 🚀
            </button>
        </div>
      )}

      <hr style={{ margin: '30px 0', border: 'none', borderTop: '1px solid #E0E0E0' }} />

      {/* 로그아웃 버튼 */}
      <div style={buttonContainerStyle}>
        <button
          className={`btn btn-sm btn-danger`}
          onClick={handleLogout}
          style={{ ...buttonStyle, backgroundColor: '#dc3545', borderColor: '#dc3545', color: 'white' }} 
        >
          로그아웃 🚪
        </button>
      </div>

            </Drawer>
        </>
    );
};
export default UserInfoDrawer;